import { default as React } from "react";
import { NavDropdown, Navbar } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import { getBusinessLabel } from "../utils";
import CustomerOrdersSpinner from "./CustomerOrdersSpinner";
import WebMenuLinks from "./WebMenuLinks";

export default function WebMenu(props) {
  const {
    toggle,
    pathname,
    userInfo,
    toggleSidebar,
    openSidebar,
    closeSidebar,
    isTabletOrMobile,
    notDeliveredItemExist,
    signoutHandler,
  } = props;
  return (
    <div style={{ position: "fixed" }}>
      <div
        style={
          toggle
            ? { position: "absolute", top: "5px", right: "5px" }
            : {
                position: "absolute",
                top: "0px",
                right: "-20px",
              }
        }
      >
        {toggle ? (
          <button
            className="linkbutton"
            style={{ color: "white" }}
            type="submit"
            onClick={() => toggleSidebar()}
          >
            <span style={{ fontSize: "30px" }}>
              <i className="fa fa-angle-double-left" />
            </span>
          </button>
        ) : (
          <button
            className="linkbutton"
            style={{
              color: pathname === "/category/order" ? "white" : "black",
              padding: "0px",
            }}
            type="submit"
            onClick={() => toggleSidebar()}
          >
            <span style={{ fontSize: "30px" }}>
              <i className="fa fa-angle-double-right" />
            </span>
          </button>
        )}
      </div>
      <div
        className="d-flex flex-column flex-shrink-0 p-3 text-bg-dark bg-dark border-secondary"
        style={{
          width: toggle ? "280px" : "80px",
          borderRight: "1px solid #dee2e6",
          zIndex: "999",
          height: "100vh",
          transition: "width 0.5s",

          overflow: "hidden",
        }}
      >
        <div
          className="d-flex flex-row"
          style={{
            height: "60px",
            justifyContent: toggle ? "flex-start" : "center",
            alignItems: "center",
          }}
        >
          {toggle && (
            <Link
              to="/"
              className="d-flex align-items-center mb-3 mb-md-0 text-white text-decoration-none"
            >
              <div>
                <Navbar.Brand>
                  <span className="whitespacenowrap">
                    {userInfo && userInfo.businessName}
                  </span>
                </Navbar.Brand>
                <div className="text-white text-muted whitespacenowrap">
                  {userInfo &&
                    (userInfo.isHelpDesk
                      ? userInfo?.client?.businessName || "Bağlantı Yok"
                      : getBusinessLabel(userInfo.businessType))}
                </div>
              </div>
            </Link>
          )}

          <CustomerOrdersSpinner
            userInfo={userInfo}
            isTabletOrMobile={isTabletOrMobile}
            notDeliveredItemExist={notDeliveredItemExist}
          ></CustomerOrdersSpinner>
        </div>
        <hr className="hr-secondary" />
        {userInfo && userInfo.isAdmin ? (
          <WebMenuLinks
            toggle={toggle}
            pathname={pathname}
            userInfo={userInfo}
          />
        ) : (
          <ul className="nav nav-pills flex-column mb-auto">
            <li className="nav-item"></li>
          </ul>
        )}
        <hr className="hr-secondary" />

        {userInfo ? (
          <NavDropdown
            onClick={() => openSidebar()}
            title={
              toggle
                ? userInfo.name
                : userInfo.name.split(" ").reduce((a, v) => a + v.charAt(0), "")
            }
            id="basic-nav-dropdown"
          >
            <div className="nav-item dropdown">
              {userInfo.isBusinessOwner && (
                <LinkContainer to="/profile">
                  <NavDropdown.Item>
                    <i className="fas fa-user-edit"></i>
                    {toggle && <>&nbsp; Hesap Bilgilerim</>}
                  </NavDropdown.Item>
                </LinkContainer>
              )}
              <Link
                className="dropdown-item"
                to="#signout"
                onClick={() => {
                  closeSidebar();
                  setTimeout(() => {
                    signoutHandler();
                  }, 2000);
                }}
              >
                <i className="fa fa-sign-out"></i>
                {toggle && <>&nbsp; Çıkış Yap</>}
              </Link>
            </div>
          </NavDropdown>
        ) : (
          <Link className="nav-link" to="/signin">
            Giriş Yap
          </Link>
        )}
      </div>
    </div>
  );
}
